import { useMemo } from 'react';
import { formatDate } from 'utils/time';

export interface UseDateConfig {
  format?: string;
  timestamp: number | undefined;
}

export default function useDate({
  format = 'MMM DD, YYYY',
  timestamp,
}: UseDateConfig): string | undefined {
  return useMemo(() => formatDate(timestamp, format), [format, timestamp]);
}
